export const loginInitialState = {
  status: '',
  token: localStorage.getItem('token') || '',
  user: localStorage.getItem('user') || ''
};
